{
  "declineButton": "Declino",
  "iAgree": "Sono d'accordo",
  "linkTo": "Visualizza i Termini di servizio",
  "title": "Termini di servizio"
}
